import {Box} from 'src/design/atoms/Box';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {IconPointer} from '@tabler/icons-react';
import React from 'react';
import {useGetSelectedField} from '../../hooks/useFormBuilder';
import {useFormBuilderRegistry} from '../../registry';

export const FieldSettings: React.FC = () => {
  const selectedField = useGetSelectedField();
  const {settingsPanels} = useFormBuilderRegistry();

  if (!selectedField) {
    return (
      <Box py="xl" ta="center">
        <IconPointer size={32} color="var(--mantine-color-dimmed)" />
        <Text size="sm" c="dimmed" mt="xs">
          Select a field from the list to configure its settings.
        </Text>
      </Box>
    );
  }

  return (
    <Stack gap="md" px="md" pb="md">
      {settingsPanels.map((Panel, index) => (
        <Panel key={index} />
      ))}
    </Stack>
  );
};
